import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute: InvariantJiraRoute = {
	name: 'rapidboard-backlog',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
	query: ['config=insightsConfig'],
};
